import React from "react";
import { Spinner, Alert, Button } from "reactstrap";
import { Breadcrumb } from "../../../components/Common";
import { usePayables } from "./hooks/usePayables";
import PayableTable from "./components/PayableTable";
import PayableForm from "./components/PayableForm";

/**
 * PayablesPage
 * Tela de Contas a Pagar — lista financialRecords do tipo EXPENSE.
 * Por padrão carrega apenas o DIA ATUAL (econômico).
 */
const PayablesPage = () => {
    document.title = "Contas a Pagar | NeoApp - Sistema de Gestão";

    const {
        records,
        summary,
        loading,
        error,
        hasMore,
        processing,
        showForm,
        statusFilter,
        search,
        startDate,
        endDate,
        setStatusFilter,
        setSearch,
        setStartDate,
        setEndDate,
        setShowForm,
        actions,
    } = usePayables();

    return (
        <React.Fragment>
            {/* ═══ HEADER ═══ */}
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb title="Contas a Pagar" />
                <Button color="primary" className="rounded-0 shadow-sm" size="sm" onClick={() => setShowForm(true)}>
                    <i className="mdi mdi-plus me-1" />
                    Nova Despesa
                </Button>
            </div>

            <div className="border-top mb-3"></div>

            {/* ═══ LOADING INICIAL ═══ */}
            {loading && !records.length && (
                <div className="text-center py-5">
                    <Spinner color="primary" />
                    <p className="text-muted mt-2">Carregando despesas...</p>
                </div>
            )}

            {/* ═══ ERRO ═══ */}
            {error && !loading && (
                <Alert color="danger" className="d-flex align-items-center">
                    <i className="mdi mdi-alert-circle-outline me-2 fs-5" />
                    <div>
                        <strong>Erro ao carregar dados:</strong> {error?.message || String(error)}
                        <button className="btn btn-link btn-sm p-0 ms-2" onClick={actions.refresh}>
                            Tentar novamente
                        </button>
                    </div>
                </Alert>
            )}

            {/* ═══ CONTEÚDO ═══ */}
            {(!loading || records.length > 0) && !error && (
                <PayableTable
                    records={records}
                    summary={summary}
                    processing={processing}
                    search={search}
                    statusFilter={statusFilter}
                    startDate={startDate}
                    endDate={endDate}
                    onSearchChange={setSearch}
                    onStatusChange={setStatusFilter}
                    onStartDateChange={setStartDate}
                    onEndDateChange={setEndDate}
                    onMarkAsPaid={actions.markAsPaid}
                    onCancel={actions.cancelRecord}
                    onLoadMore={actions.loadMore}
                    hasMore={hasMore}
                    loading={loading}
                />
            )}

            {/* ═══ MODAL NOVA DESPESA ═══ */}
            <PayableForm
                isOpen={showForm}
                toggle={() => setShowForm(false)}
                onSave={actions.createPayable}
                processing={processing}
            />
        </React.Fragment>
    );
};

export default PayablesPage;
